import Image from "next/image";
import { Fragment } from "react";
import ImageWithFallback from "./ImageWithFallback";
import { formatScore, ordinalValue } from "../lib/helpers";
import { PlayerImage } from "./PlayerImage";

function MissedCut() {
  return (
    <div className="absolute top-0 object-cover">
      <Image
        alt="Missed cut"
        width="400"
        height="400"
        src="https://stgolfchampsprodeastus.blob.core.windows.net/public/missed_cut.png"
      />
    </div>
  );
}

function DidNotFinish() {
  return (
    <div className="absolute top-0 object-cover">
      <Image
        alt="DidNotFinish"
        width="400"
        height="400"
        src="https://stgolfchampsprodeastus.blob.core.windows.net/public/mdf.png"
      />
    </div>
  );
}

function Withdrawn() {
  return (
    <div className="absolute top-0 object-cover">
      <Image
        width="400"
        height="400"
        src="https://stgolfchampsprodeastus.blob.core.windows.net/public/withdrawn.png"
        unoptimized
      />
    </div>
  );
}

const textSnippet = (snippet) => (
  <div className="text-right text-white font-semibold text-[12px]">
    {snippet}
  </div>
);

const positionSnippet = (pos, ordinal) => (
  <div className="text-right text-white font-semibold text-[12px]">
    Position: {pos}
    <sup>{ordinal}</sup>
  </div>
);

const scoreDetails = (item) => (
  <>
    {item?.ScoreDetails?.Totals?.position
      ? positionSnippet(
          item?.ScoreDetails?.Totals?.position,
          ordinalValue(item?.ScoreDetails?.Totals?.position),
        )
      : null}
    {item?.ScoreDetails?.Totals?.holesPlayed
      ? textSnippet(`Thru: ${item?.ScoreDetails?.Totals?.holesPlayed}`)
      : null}
    {item?.ScoreDetails?.Totals?.totalToPar
      ? textSnippet(
          `Par: ${formatScore(item?.ScoreDetails?.Totals?.totalToPar)}`,
        )
      : null}
    {item?.ScoreDetails?.Totals?.status != "ok"
      ? textSnippet(
          `Given: ${formatScore(item?.ScoreDetails?.Totals?.givenScore)}`,
        )
      : null}
  </>
);

function EntryItem(item) {
  // console.log("Entry Item is", item);
  return (
    <div
      key={item.id}
      className="relative flex flex-col content-end items-end bg-black h-[220px] overflow-hidden"
    >
      <Image
        src={
          item.image ||
          "https://stgolfchampsprodeastus.blob.core.windows.net/public/not_found.png"
        }
        alt={`${item.first_name}_${item.last_name}`}
        layout="fill"
        className="object-cover rounded-t-md w-100 h-100"
        unoptimized
      />
      {item?.ScoreDetails?.Totals?.status === "cut" ? <MissedCut /> : null}
      {item?.ScoreDetails?.Totals?.status === "dnf" ? <DidNotFinish /> : null}
      {["wd", "retired", "disqualified"].includes(
        item?.ScoreDetails?.Totals?.status,
      ) ? (
        <Withdrawn />
      ) : null}
      <div className="font-bold text-[14px] text-white absolute top-0 left-0 right-0 h-[50px] bg-[#00000066] items-center justify-center flex px-[16px] whitespace-nowrap truncate ...">
        <span className="min-w-0 whitespace-nowrap truncate">
          {item.first_name} {item.last_name}
        </span>
      </div>
      {/* <div className="absolute top-2 right-2 bg-slate-800 opacity-60 m-1 text-right pl-1 pr-1 pb-0.5 rounded font-serif text-white text-md sm:text-sm ">
        Rank:
        {' '}
        {item.rank}
      </div> */}
      <div className="absolute bottom-0 left-0 right-0 bg-[#00000066] p-[8px]">
        {textSnippet(`Rank: ${item.rank}`)}
        {item.ScoreDetails && scoreDetails(item)}
      </div>
    </div>
  );
}

function Entry(props) {
  const totalRank =
    (props.players &&
      props?.players.reduce((acc, curr) => curr.rank + acc, 0)) ||
    0;
  // console.log('Total Rank is ', totalRank);
  return (
    <Fragment>
      <div className="flex justify-between h-[50px] bg-black text-white font-['Montserrat'] text-[15px] items-center px-[16px] mb-[10px]">
        <span>Entry</span>
        <span>Total Rank: {totalRank}</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-[8px]">
        {props.players && props.players.map((player) => EntryItem(player))}
      </div>
    </Fragment>
  );
}

export default Entry;
